<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          class="mb-6"
          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
          <v-card-text>
            <ValidationProvider 
              name="Nomor Surat" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Nomor Surat
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. SRT/PRK/20240102/0001"
                hide-details

                v-model="form.number"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Nomor Surat {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.number !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider 
              name="Tujuan Penerima" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tujuan Penerima
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. John Doe"
                hide-details

                v-model="form.for"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-3"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Tujuan Penerima {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.for !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <ValidationProvider 
          name="Nama File" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama File
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Surat Menyurat"
            hide-details

            v-model="form.title"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama File {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.title !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Nomor" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nomor
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. 005/PT.UMB/IV/2022"
            hide-details

            v-model="form.template_meta_json_object.nomor"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 70%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nomor {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nomor !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Lampiran" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Lampiran
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. 1 Lembar"
            hide-details

            v-model="form.template_meta_json_object.lampiran"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 50%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Lampiran {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.lampiran !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Hal" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Hal
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Pemberitahuan"
            hide-details

            v-model="form.template_meta_json_object.hal"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 70%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Hal {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.hal !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <v-btn
          @click="add_pegawai()"

          color="#444444"
          elevation="0"
          class="text-capitalize white--text mb-4"
          style="border-radius: 10px;">
          Tambah Pegawai Yang Diundang
        </v-btn>

        <div
          v-for="(item, index) in form.template_meta_json_object.kepada"
          :key="index">
          <v-card
            flat
            class="pa-3 mb-6"
            style="border: 2px dashed #f0f0f0; border-radius: 10px;">
            <v-btn
              @click="form.template_meta_json_object.kepada.splice(index, 1)"

              icon
              style="position: absolute; top: -15px; right: -15px;">
              <v-icon
                color="red">
                mdi-close-circle
              </v-icon>
            </v-btn>

            <ValidationProvider 
              :name="`Nama Yang Diundang ${index + 1}`" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Nama Yang Diundang {{ index + 1 }}
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. Wildan Faizal Imawan"
                hide-details

                v-model="item.nama"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Nama Yang Diundang {{ index + 1 }} {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="item.nama !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider 
              :name="`Jabatan Yang Diundang ${index + 1}`" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Jabatan Yang Diundang {{ index + 1 }}
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. Direktur Utama"
                hide-details

                v-model="item.unit"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-3"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Jabatan Yang Diundang {{ index + 1 }} {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="item.unit !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-card>
        </div>

        <ValidationProvider 
          name="Hari Libur" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Hari Libur
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Hari Raya Idul Fitri M\/1444H"
            hide-details

            v-model="form.template_meta_json_object.hari_libur"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Hari Libur {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.hari_libur !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <v-row>
          <v-col
            cols="12"
            md="5"
            class="py-0">
            <div>
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tanggal Mulai
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>

              <v-menu
                ref="tanggal_mulai"
                min-width="290px"
                max-width="290px"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                :close-on-content-click="false"
                v-model="picker.tanggal_mulai">
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider 
                    name="Tanggal Mulai" 
                    rules="required"
                    v-slot="{ errors, valid }">
                    <v-text-field
                      readonly
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Pilih Tanggal"
                      hide-details
                      clearable

                      @click:clear="form.template_meta_json_object.tanggal_mulai = null; form.template_meta_json_object.tanggal_selesai = null;"
                      v-on="on"
                      v-bind="attrs"

                      v-model="form.template_meta_json_object.tanggal_mulai"
                      :success="form.template_meta_json_object.tanggal_mulai !== null && valid"
                      :error-messages="errors"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Tanggal Mulai {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.template_meta_json_object.tanggal_mulai !== null && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </template>

                <v-date-picker 
                  :color="set_color"
                  v-model="form.template_meta_json_object.tanggal_mulai"
                  @input="picker.tanggal_mulai = false; form.template_meta_json_object.tanggal_selesai = null;">
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>

          <v-col
            cols="12"
            md="5"
            class="py-0">
            <div>
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tanggal Selesai
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>

              <v-menu
                ref="tanggal_selesai"
                min-width="290px"
                max-width="290px"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                :close-on-content-click="false"
                v-model="picker.tanggal_selesai">
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider 
                    name="Tanggal Selesai" 
                    rules="required"
                    v-slot="{ errors, valid }">
                    <v-text-field
                      readonly
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Pilih Tanggal"
                      hide-details
                      clearable

                      @click:clear="form.template_meta_json_object.tanggal_selesai = null;"
                      v-on="on"
                      v-bind="attrs"

                      v-model="form.template_meta_json_object.tanggal_selesai"
                      :success="form.template_meta_json_object.tanggal_selesai !== null && valid"
                      :error-messages="errors"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Tanggal Selesai {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.template_meta_json_object.tanggal_selesai !== null && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </template>

                <v-date-picker 
                  :color="set_color"
                  :min="form.template_meta_json_object.tanggal_mulai"
                  v-model="form.template_meta_json_object.tanggal_selesai"
                  @input="picker.tanggal_selesai = false">
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>
        </v-row>

        <div>
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Tanggal Masuk
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <v-menu
            ref="tanggal_masuk"
            min-width="290px"
            max-width="290px"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            :close-on-content-click="false"
            v-model="picker.tanggal_masuk">
            <template v-slot:activator="{ on, attrs }">
              <ValidationProvider 
                name="Tanggal Masuk" 
                rules="required"
                v-slot="{ errors, valid }">
                <v-text-field
                  readonly
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Pilih Tanggal"
                  hide-details
                  clearable

                  @click:clear="form.template_meta_json_object.tanggal_masuk = null;"
                  v-on="on"
                  v-bind="attrs"

                  v-model="form.template_meta_json_object.tanggal_masuk"
                  :success="form.template_meta_json_object.tanggal_masuk !== null && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tanggal Masuk {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.template_meta_json_object.tanggal_masuk !== null && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </template>

            <v-date-picker 
              :color="set_color"
              v-model="form.template_meta_json_object.tanggal_masuk"
              @input="picker.tanggal_masuk = false">
            </v-date-picker>
          </v-menu>
        </div>

        <ValidationProvider 
          name="Informasi Lain" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Informasi Lain
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-textarea
            filled
            rounded
            dense
            :color="set_color"

            rows="3"
            
            placeholder="Contoh. perihal dengan Syawalan Keluarga Besar PT. Umat Mandiri Berkemajuan akan diinformasikan kembali (menyusul melalui surat resmi)"
            hide-details

            v-model="form.template_meta_json_object.informasi_lain"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Informasi Lain {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.informasi_lain !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-textarea>
        </ValidationProvider>

        <div>
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Tanggal
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <v-menu
            ref="tanggal"
            min-width="290px"
            max-width="290px"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            :close-on-content-click="false"
            v-model="picker.tanggal">
            <template v-slot:activator="{ on, attrs }">
              <ValidationProvider 
                name="Tanggal" 
                rules="required"
                v-slot="{ errors, valid }">
                <v-text-field
                  readonly
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Pilih Tanggal"
                  hide-details
                  clearable

                  @click:clear="form.template_meta_json_object.tanggal = null;"
                  v-on="on"
                  v-bind="attrs"

                  v-model="form.template_meta_json_object.tanggal"
                  :success="form.template_meta_json_object.tanggal !== null && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tanggal {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </template>

            <v-date-picker 
              :color="set_color"
              v-model="form.template_meta_json_object.tanggal"
              @input="picker.tanggal = false">
            </v-date-picker>
          </v-menu>
        </div>

        <ValidationProvider 
          name="Nama Yang Bertandatangan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama Yang Bertandatangan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
            hide-details

            v-model="form.template_meta_json_object.nama_1"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama Yang Bertandatangan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nama_1 !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Jabatan Yang Bertandatangan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Jabatan Yang Bertandatangan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Direktur Utama PT.UMB."
            hide-details

            v-model="form.template_meta_json_object.jabatan_1"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-3"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Jabatan Yang Bertandatangan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.jabatan_1 !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
          <div
            ref="arsippdf"
            style="padding: 50px;">
            <v-card-text
              class="black--text py-2">
              <v-row>
                <v-col
                  cols="12"
                  md="7">
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Nomor
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.nomor !== '' ? form.template_meta_json_object.nomor : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Lampiran
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.lampiran !== '' ? form.template_meta_json_object.lampiran : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Hal
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : <span style="font-weight: 500;">{{ form.template_meta_json_object.hal !== '' ? form.template_meta_json_object.hal : '__________' }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <div
                class="mt-6"
                style="margin-top: 24px !important;">
                <div
                  style="margin-bottom: 1px;">
                  Kepada Yth.
                </div>

                <div
                  v-for="(item, index) in form.template_meta_json_object.kepada"
                  :key="index"
                  class="d-flex align-center"
                  style="margin-bottom: 1px; display: flex !important; align-items: center !important;">
                  <span>
                    {{ index + 1 }}.
                  </span>

                  <span
                    class="mx-2"
                    style="margin-right: 8px !important; margin-left: 8px !important;">
                    {{ item.nama !== '' ? item.nama : '__________' }}
                  </span>

                  <span>
                    ({{ item.unit !== '' ? item.unit : '__________' }})
                  </span>
                </div>

                <div
                  style="margin-bottom: 1px;">
                  di lingkungan PT. Umat Mandiri Berkemajuan
                </div>
              </div>

              <div
                class="mt-10"
                style="margin-top: 40px !important;">
                <v-img
                  contain
                  width="175"
                  height="auto"
                  alt="umb" 
                  :src="require('@/assets/image/assalam.jpeg')">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>

                <div
                  class="my-4"
                  style="margin-top: 16px !important; margin-bottom: 16px !important;">
                  <div
                    class="mb-4"
                    style="text-indent: 30px; margin-bottom: 16px !important;">
                    Dengan hormat, sehubungan dengan memasukinya {{ form.template_meta_json_object.hari_libur !== '' ? form.template_meta_json_object.hari_libur : '__________' }}, maka bersama surat ini kami sampaikan informasi sebagai berikut :
                  </div>

                  <div
                    class="mb-4"
                    style="margin-left: 22px; margin-bottom: 16px !important;">
                    <ol
                      type="a">
                      <li
                        class="pl-2"
                        style="padding-left: 8px !important;">
                        Libur menjelang {{ form.template_meta_json_object.hari_libur !== '' ? form.template_meta_json_object.hari_libur : '__________' }} dimulai pada tanggal
                        <span v-if="form.template_meta_json_object.tanggal_mulai !== '' && form.template_meta_json_object.tanggal_mulai !== null">
                          {{ form.template_meta_json_object.tanggal_mulai | day }}
                        </span>

                        <span v-else>
                          __________
                        </span>

                        -

                        <span v-if="form.template_meta_json_object.tanggal_selesai !== '' && form.template_meta_json_object.tanggal_selesai !== null">
                          {{ form.template_meta_json_object.tanggal_selesai | fulldate }}
                        </span>

                        <span v-else>
                          __________
                        </span>
                      </li>

                      <li
                        class="pl-2"
                        style="padding-left: 8px !important;">
                        Kegiatan dan aktifitas di lingkungan PT. UMB mulai aktif kembali pada tanggal
                        <span v-if="form.template_meta_json_object.tanggal_masuk !== '' && form.template_meta_json_object.tanggal_masuk !== null">
                          {{ form.template_meta_json_object.tanggal_masuk | fulldate }}
                        </span>

                        <span v-else>
                          __________
                        </span>
                      </li>

                      <li
                        class="pl-2"
                        style="padding-left: 8px !important;">
                        Informasi atau kebijakan lain {{ form.template_meta_json_object.informasi_lain !== '' ? form.template_meta_json_object.informasi_lain : '__________' }}.
                      </li>
                    </ol>
                  </div>

                  <div
                    class="mb-4"
                    style="text-indent: 30px; margin-bottom: 16px !important;">
                    Selanjutnya, mohon bagi pimpinan unit bisnis PT. UMB untuk menyampaikan infromasi tersebut di unit bisnis masing-masing.
                  </div>

                  <div
                    style="text-indent: 30px;">
                    Demikian pemberitahuan ini kami sampaikan atas perhatian dan kerjasamanya diucapkan terima kasih.
                  </div>
                </div>

                <v-img
                  contain
                  width="175"
                  height="auto"
                  alt="umb" 
                  :src="require('@/assets/image/wassalam.jpeg')">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>

              <v-row
                justify="end"
                class="mt-8"
                style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                <v-col
                  cols="12"
                  md="6"
                  class="text-center"
                  style="text-align: center !important;">
                  <div>
                    Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                  </div>

                  <div
                    class="mb-16"
                    style="margin-bottom: 64px !important;">
                    {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                  </div>

                  <div>
                    {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      },
      units: {
        type: Array,
        default: []
      },
      process: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        picker: {
          expired: false,
          tanggal: false,
          tanggal_mulai: false,
          tanggal_selesai: false,
          tanggal_masuk: false,

          range: false
        },

        time: {
          pukul: false
        },
      }
    },
    components: {
      
    },
    watch: {

    },
    computed: {
      user () {
        return this.$store.state.user
      },
      
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      // formattedDate: {
      //   get () {
      //     return (this.form.template_meta_json_object.tanggal && this.form.template_meta_json_object.tanggal.length === 10) ? moment(this.form.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.template_meta_json_object.tanggal
      //   },
      //   set (newValue) {
      //     if (newValue && newValue.length == 10) {
      //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
      //         this.form.template_meta_json_object.tanggal = newDate
      //     }
      //   }
      // },

      date_range () {
        return this.filter.dates.join(' s/d ')
      }
    },
    mounted () {
      
    },
    methods: {
      add_pegawai () {
        this.form.template_meta_json_object.kepada.push({
          nama: '',
          unit: ''
        })
      },
    }
  }
</script>
